import { z } from 'zod/v4';

import { unitsOfMeasurementSchema } from '../../../schemas/units-of-measurement.schema';

export const vehicleDimensionSchema = z.object({
  height: z.number(),
  length: z.number(),
  units: unitsOfMeasurementSchema,
  weight: z.number(),
  width: z.number(),
  maxWeightPerAxleGroup: z.number().optional(),
});

export type VehicleDimension = z.infer<typeof vehicleDimensionSchema>;
